const initialState = {
  assemblies: [],
};

const assemblies = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ASSEMBLIES':
      return { assemblies: action.assemblies };
    default:
      return state;
  }
};

export default assemblies;
